let _InternalNodeEnum = Blackprint._InternalNodeEnum = {
	BPEnvGet: 0,
	BPEnvSet: 1,
	BPVarGet: 2,
	BPVarSet: 3,
	BPFnVarInput: 4,
	BPFnVarOutput: 5, // Not used, but reserved
	BPFnInput: 6,
	BPFnOutput: 7,
	BPFnMain: 8,
	BPEventListen: 9,
	BPEventEmit: 10,
};